export default "__VITE_ASSET__c084eb79__"